import { render, staticRenderFns } from "./ProductGroupDeal.vue?vue&type=template&id=6e0e2051&"
import script from "./ProductGroupDeal.vue?vue&type=script&lang=js&"
export * from "./ProductGroupDeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports